import { FiltroAgente } from './filtro-agente';
import { FiltroCliente } from './filtro-cliente';

export class FiltroBuscarCliente {
    datosCliente: FiltroCliente;
    datosAgente: FiltroAgente;
    constructor(datosCliente: FiltroCliente, datosAgente: FiltroAgente) {
        this.datosCliente = datosCliente;
        this.datosAgente = datosAgente;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/filtro/filtro-buscar-cliente.ts